import { RefObject, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { scrollToTop } from "modules/scrollToTop";

// Reset scroll to the top on every route change.
//
// React Router preserves the scroll offset across client-side navigations, so
// opening e.g. an access catalog from a scrolled-down page would otherwise land
// mid-page with the catalog name hidden (PLO-4925). We key on `pathname` only:
// the catalog item modal toggles a `?item_id=` search param on the *same* path
// (see CatalogItem), and that must not yank the page back to the top.
//
// The member dashboard has two scroll containers depending on breakpoint:
// desktop scrolls the document (`window`); mobile (<=767px) scrolls the
// `<main>` element internally. Reset both — whichever isn't the active scroller
// is a harmless no-op.
const ScrollToTop = ({
  containerRef,
}: {
  containerRef?: RefObject<HTMLElement | null>;
}) => {
  const { pathname } = useLocation();

  useEffect(() => {
    scrollToTop(window, containerRef?.current);
  }, [pathname, containerRef]);

  return null;
};

export default ScrollToTop;
